import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { HttpService } from '../../service/http.service';
import { eventEmitterService } from '../../service/eventEmitter.service';

@Component({
  selector: 'app-report-to-mycoop',
  templateUrl: './report-to-mycoop.component.html',
  styleUrls: ['./report-to-mycoop.component.css']
})
export class ReportToMycoopComponent implements OnInit {

  
  @Input() conflictAddress: string;


  reportCoop: FormGroup;
  submited: boolean;
  modalDismiss: string;
  error;
  isLoadingActive = false;
  isSuccess = false;
  successMessage: string;
  alert;
  ModalTrigger = false;
  modalToOpen;
  modalTarget;
  errorState: boolean = false;


  emailInvalid = false;
  commentInvalid = false;
  submitted:boolean = false;

  @ViewChild('submitbuild', { static: false })
  public submit: ElementRef;

  constructor(
              private _fb: FormBuilder,
              private httpService: HttpService,
              private emitter: eventEmitterService
              ) { }
  ngOnInit() {

    this.emitter.eventEmit$.subscribe((data)=>{
      if(data.conflict_Adr){
        this.conflictAddress = data.conflict_Adr;
      }
    })

    this.reportCoop = this._fb.group({
      'email': new FormControl('', [Validators.required,
        Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]),
      'comments': new FormControl('', Validators.required)
    });

    if(this.reportCoop.get('email').invalid && this.reportCoop.get('email').touched){
      this.emailInvalid = true;
    }else {
      this.emailInvalid = false;
    }

    if(this.reportCoop.get('comments').invalid && this.reportCoop.get('comments').touched){
      this.commentInvalid = true;
    }else {
      this.commentInvalid = false;
    }
  }

  clearError(field){
    if(field === 'email'){
      this.emailInvalid = false;
    }else if(field === 'comment'){
      this.commentInvalid = false;
    }
   }

   reportMycoop() {
    this.submitted = true;

      this.emailInvalid = this.reportCoop.get('email').hasError('required');
      this.commentInvalid = this.reportCoop.get('comments').hasError('required') || this.reportCoop.get('comments').value.trim().length <= 0;

    if (this.reportCoop.valid && !this.emailInvalid && !this.commentInvalid) {
      this.isLoadingActive = true;
      const reportForm = {
        formValue :  this.reportCoop.value,
        conflictAddress : this.conflictAddress
      };

      this.httpService.reportAddressToMycoop(reportForm).subscribe(
        (response) => {
          if (response) {
            this.isLoadingActive = false;
          }
          if(response.ok){
            this.isSuccess = true;
            this.successMessage = 'Thank you for reporting your issue.  Someone from mycoop will follow up with you shortly!';
            this.reportCoop.reset();
          }

        },
        (error) => {
          console.log(error);
        }
      );
    }

  }
  closeDialog(){
    setTimeout(() => {
      this.isSuccess = false;
    }, 3000);
  }

}
